import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { Box } from '@material-ui/core'

import SublicensingsRow from '../SublicensingsRow'
import PerfectScrollbar from 'react-perfect-scrollbar'

import PropTypes from 'prop-types'

const SublicensingsTable = ({ preRegistrations, refresh }) => {
  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: true, useBothWheelAxes: true }}
      >
        <Table emptyMessage="Nenhum encontrado" noWrap>
          <TableHead>
            <TableRow>
              <TableCell width="5%">ID</TableCell>
              <TableCell width="25%" align="left">
                Nome
              </TableCell>
              <TableCell width="20%" align="left">
                CNPJ/CPF
              </TableCell>
              <TableCell width="15%" align="left">
                Nº de Contratos
              </TableCell>
              <TableCell width="20%" align="left">
                MMR (todos os contratos)
              </TableCell>
              <TableCell width="10%" align="left">
                Status
              </TableCell>
              <TableCell width="5%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {preRegistrations.map((preRegistration) => (
              <SublicensingsRow
                preRegistration={preRegistration}
                key={preRegistration.id}
                refresh={refresh}
              />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

SublicensingsTable.propTypes = {
  preRegistrations: PropTypes.arrayOf(Object),
}

export default SublicensingsTable
